import { UatSessionSummary } from 'src/store/interfaces/Uat.types';

// Mirrors the service rule: owner or admin. An empty/unknown currentUser must never match an
// empty createdBy, which is why the falsy check comes before the comparison.
export function canDeleteSession(
  session: Pick<UatSessionSummary, 'createdBy'>,
  currentUser: string | null | undefined,
  isAdmin: boolean,
): boolean {
  if (isAdmin) return true;
  if (!currentUser) return false;
  return session.createdBy === currentUser;
}
